import {Accordion, Badge, Button, Card, Col, Form, Modal, Row, Table} from 'react-bootstrap'
import {NodeSignatureForm} from '../../../types/signatureFormsApi'
import moment from 'moment'
import {InputCurrency} from '../../../components/InputCurrency'
import {Link} from 'react-router-dom'
import {parseId} from '../../../helpers'

const METALS_INFO = {
  '5': 'Platinum',
  '4': 'Gold',
  '3': 'Silver',
  '2': 'Bronze',
  '1': 'Catastrophic',
}

export const ModalPreview: React.FC<{
  onClose: () => void
  isOpen: boolean
  info: NodeSignatureForm
}> = ({info, isOpen, onClose}) => {
  return (
    <Modal show={isOpen} onHide={onClose} size='xl'>
      <Modal.Header closeButton>
        <Modal.Title>Preview of {info.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{backgroundColor: '#f2f3f8'}}>
        <Card>
          <Card.Body>
            <Form.Group>
              <Form.Label>Form Content</Form.Label>
              <div
                style={{
                  border: '1px solid #ced4da',
                  borderRadius: '0.375rem',
                  background: '#fff',
                  minHeight: 120,
                  padding: 12,
                  overflowX: 'auto',
                  width: '100%',
                }}
                dangerouslySetInnerHTML={{ __html: info.formContent || '' }}
              />
            </Form.Group>
          </Card.Body>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
